const React = require('react');
const {OwnersList} = require('../../../../../dumb/AdminHelpers/AdminUserRegistration');
const {
  apiAdminMerchantOwnerCreate,
  apiAdminMerchantOwnerUpdate,
  apiAdminMerchantOwnerDelete
} = require("../../../../../../api/admin/retailersCreate");

module.exports = (props) => {
  return (
    <OwnersList
      activeUserId={props.activeUserId}
      ownersList={((props.stepsData || {}).company || {}).owners}
      resetUserData={props.resetUserData}
      onNextStep={props.onNextStep}
      requestCreate={apiAdminMerchantOwnerCreate}
      requestUpdate={apiAdminMerchantOwnerUpdate}
      requestDelete={apiAdminMerchantOwnerDelete}
    />
  )
}
